import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from '../../services/common/base.http.service';
import { IPersonComplete } from '../../models/person.model';
import { Observable } from 'rxjs';
import { enterRequestConst } from '../enterRequest.const';
import { IRequestType } from '../models/request-type.model';
import { ILineType } from '../../administration/models/line-type.model';
import { IEnterRequest } from '../models/enter-request.model';
import { HttpHeaders } from "@angular/common/http";
import { EnterRequestAction } from '../enums/enter-request-action.enum';
import { EnterRequestResponse } from '../models/enter-request-response.model';

@Injectable({
  providedIn: 'root'
})
export class EnterRequestService {
  baseHttpService = inject(BaseHttpService);
  constructor() { }

  getPersonCompleteData(email: string): Observable<IPersonComplete> {
    return this.baseHttpService.get<IPersonComplete>(enterRequestConst.personCompleteData + email);
  }

  getAllRequestTypes(): Observable<IRequestType[]> {    
    return this.baseHttpService.get<IRequestType[]>(enterRequestConst.requestTypesApiUrl);
  }

  getLineTypes(employeeNo: number, requestType: string, mode: string, skipBenefitBasedLineTypes: boolean): Observable<ILineType[]> {
    return this.baseHttpService.get<ILineType[]>(enterRequestConst.lineTypesApiUrl + `?employeeNo=${employeeNo}&requestType=${requestType}&mode=${mode}&skipBenefitBasedLineTypes=${skipBenefitBasedLineTypes}`);
  }

  enterRequest(request: IEnterRequest, action: EnterRequestAction): Observable<EnterRequestResponse> {
    const headers = new HttpHeaders({ 'content-type': 'application/x-www-form-urlencoded' });
    return this.baseHttpService.post<EnterRequestResponse>(enterRequestConst.enterRequest + action.toString(), this.convertToFormData(request), {header: headers});
  }

  private convertToFormData(request: IEnterRequest): FormData {
    const formData = new FormData();
    formData.append('userName', request.userName);
    formData.append('userEmail', request.userEmail);
    formData.append('employeeName', request.employeeName);
    formData.append('employeeEmail', request.employeeEmail);
    formData.append('employeeNo', request.employeeNo?.toString() || '');
    formData.append('employeeType', request.employeeType);
    formData.append('payableToNo', request.payableToNo.toString());
    formData.append('approver', request.approver);
    formData.append('requestNumber', request.requestNumber?.toString());
    formData.append('requestStatus', request.requestStatus);
    formData.append('approverName', request.approverName);
    formData.append('approverEmail', request.approverEmail);
    formData.append('requestTitle', request.requestTitle);
    formData.append('chargeAfeCc', request.chargeAfeCc);
    formData.append('jobTitle', request.jobTitle);
    formData.append('costCenter', request.costCenter);
    formData.append('divisionId', request.divisionId);
    formData.append('division', request.division);
    formData.append('locationId', request.locationId);
    formData.append('location', request.location);
    formData.append('requestType', request.requestType);
    formData.append('mode', request.mode);
    formData.append('inRegardOf', request.inRegardOf);
    formData.append('howPaid', request.howPaid);
    formData.append('confidential', request.confidential.toString());
    formData.append('totalAmount', request.totalAmount.toString());

    request.attachments.forEach((file, index) => {
        formData.append(`attachments[${index}]`, file, file.name);
    });

    request.requestDetails.forEach((detail, index) => {
        formData.append(`requestDetails[${index}].lineType.type`, detail.lineType.type);
        formData.append(`requestDetails[${index}].amount`, detail.amount?.toString() || '');
        formData.append(`requestDetails[${index}].accountId`, detail.accountId || '');
        formData.append(`requestDetails[${index}].accountNumber`, detail.accountNumber || '');
        formData.append(`requestDetails[${index}].description`, detail.description || '');
        formData.append(`requestDetails[${index}].from`, detail.from || '');
        formData.append(`requestDetails[${index}].to`, detail.to || '');
        formData.append(`requestDetails[${index}].factor`, detail.factor?.toString() || '' );
        formData.append(`requestDetails[${index}].rate`, detail.rate?.toString() || '');
        formData.append(`requestDetails[${index}].limit`, detail.limit?.toString() || '');
    });
    return formData;
  }
}